import { axiosClient } from "../axios";

export function getUserQualifications(id) {
  return axiosClient.get(`qualifications/${id}`);
}

export function insertSingle(data) {
  return axiosClient.post("qualifications/insert", data);
}

export function insertMultipleQualifications(userId, data) {
  return axiosClient.post(`qualifications/insert/${userId}/multiple`, data);
}

export function update(data) {
  return axiosClient.post(`qualifications/${data.id}/update`, data);
}

export function remove(qualificationId) {
  return axiosClient.delete(`qualifications/${qualificationId}/delete`);
}
